const STORAGE_KEY = 'infoBannerDismissed';

function run() {
	const banner = document.querySelector('[data-info-banner]');
	if (!banner) {
		return;
	}

	// TEMPORÄR für Test-Phase
	// vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
	// const resetBtn = document.querySelector('[data-info-banner-reset]');
	// console.log('ok');

	// if (resetBtn) {
	// 	resetBtn.addEventListener('click', (e) => {
	// 		e.preventDefault();
	// 		try {
	// 			localStorage.removeItem(STORAGE_KEY);
	// 		} catch {
	// 			console.log('Fehler beim Zurücksetzen des Info-Banners');
	// 		}
	// 		banner.removeAttribute('hidden');
	// 	});
	// }
	// ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^


	const dismissBtn = banner.querySelector('[data-info-banner-dismiss]');
	const infoBtn = banner.querySelector('[data-info-banner-info]');

	try {
		if (localStorage.getItem(STORAGE_KEY) === '1') {
			return;
		}
	} catch {
		// localStorage nicht verfügbar (z. B. private mode) — Banner anzeigen
	}

	banner.removeAttribute('hidden');

	if (!dismissBtn) {
		return;
	}

	dismissBtn.addEventListener('click', () => {
		try {
			localStorage.setItem(STORAGE_KEY, '1');
		} catch {
			// ignorieren
		}
		banner.setAttribute('hidden', '');

		// A11y: Fokus-Management nach Interaktion.
		// Verhindert, dass der Fokus beim Schließen auf dem Trigger-Element verbleibt
		// und leitet den Fokus zum Hauptinhalt zurück (Accessibility-Requirement)
		const main = document.getElementById('onepager') || document.querySelector('main');
		if (main) {
			main.setAttribute('tabindex', '-1');
			main.focus();
			requestAnimationFrame(() => main.removeAttribute('tabindex'));
		}
	});

	// TODO: In Funktion auslagern, weil zweimal dieselbe Logik verwendet wird
	infoBtn.addEventListener('click', () => {
		try {
			localStorage.setItem(STORAGE_KEY, '1');
		} catch {
			// ignorieren
		}
		banner.setAttribute('hidden', '');

		// A11y: Fokus-Management nach Interaktion.
		// Verhindert, dass der Fokus beim Schließen auf dem Trigger-Element verbleibt
		// und leitet den Fokus zum Hauptinhalt zurück (Accessibility-Requirement)
		const main = document.getElementById('onepager') || document.querySelector('main');
		if (main) {
			main.setAttribute('tabindex', '-1');
			main.focus();
			requestAnimationFrame(() => main.removeAttribute('tabindex'));
		}
	});

}

export function initInfoBanner() {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
}
